import {
  Block,
  HeadingMedium,
  ParagraphLarge,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import mezoLogo from "#/assets/mezo-logo-inline.svg"

export default function OnboardingModalSignInHeader() {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
      })}
    >
      <ParagraphSmall marginBottom={theme.sizing.scale300}>
        Welcome to
      </ParagraphSmall>
      <Block
        marginBottom={theme.sizing.scale900}
        as="img"
        width="88px"
        src={mezoLogo}
      />
      <HeadingMedium marginBottom={theme.sizing.scale300}>
        Sign in
      </HeadingMedium>
      <ParagraphLarge marginBottom={theme.sizing.scale900}>
        Use your existing wallet to sign in
      </ParagraphLarge>
    </Block>
  )
}
